import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shared-hosting',
  templateUrl: './shared-hosting.component.html',
  styleUrls: ['./shared-hosting.component.scss']
})
export class SharedHostingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
